import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado de Pisos y Casas',
      description:
        'Vaciado completo de viviendas para herencias, mudanzas o desahucios. Retiramos todo tipo de enseres y dejamos el espacio impecable.',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vaciado de Locales Comerciales',
      description:
        'Servicio especializado en vaciado de locales, oficinas y naves. Ideal para traspasos, cierres o renovaciones de espacios comerciales.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Retirada de Muebles y Electrodomésticos',
      description:
        'Recogida y gestión responsable de muebles, electrodomésticos y enseres. Nos encargamos del reciclaje y la gestión de residuos.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Limpieza por Síndrome de Diógenes',
      description:
        'Servicio discreto y profesional para casos de acumulación compulsiva. Tratamos cada situación con sensibilidad y respeto absoluto.',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura Final',
      description:
        'Dejamos tu piso listo para alquilar o vender con nuestro servicio de pintura. Acabados profesionales que revalorizan tu propiedad.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Pequeñas Reparaciones',
      description:
        'Arreglos menores para la entrega de llaves: grifería, cerraduras, enchufes y otros detalles que marcan la diferencia.',
    },
  ];

  return (
    <section className="py-24 bg-secondary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Nuestros servicios en Mollet del Vallès
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto"></div>
          <p className="mt-6 text-lg text-gray-700 max-w-3xl mx-auto">
            Ofrecemos soluciones completas de vaciado y limpieza profesional en Mollet del Vallès, Parets del Vallès, Montmeló, Granollers y toda la comarca del Vallès Oriental. Más de 10 años de experiencia nos avalan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 relative overflow-hidden cursor-pointer"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
              }}
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-primary transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>

              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-primary`}></i>
              </div>

              <h3 className="text-xl font-semibold text-dark mb-4">{service.title}</h3>

              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>

              <Link
                to="/servicios"
                className="inline-flex items-center text-primary font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Más información
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/servicios"
            className="inline-flex items-center space-x-2 bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <span>Ver Todos los Servicios</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;